"use client";

import { c as _c } from "react/compiler-runtime";
import { Monitor } from "lucide-react";
export function MobileGuard(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex size-16 items-center justify-center rounded-2xl bg-primary/10"><Monitor className="size-8 text-primary" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="contents md:hidden"><div className="flex min-h-dvh flex-col items-center justify-center bg-background px-8 text-center"><div className="mx-auto flex max-w-sm flex-col items-center gap-6">{t1}<div className="flex flex-col gap-2"><h1 className="font-heading font-semibold text-xl tracking-tight">Desktop experience only</h1><p className="text-muted-foreground text-sm leading-relaxed">fabric is designed for desktop browsers. Please switch to a computer with a larger screen for the best experience.</p></div></div></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <>{t2}<div className="hidden md:contents">{children}</div></>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}